<template>
  <div class="order-details-modal">
    <ion-header>
      <ion-toolbar>
        <ion-title>
          Order Details - {{ customerName }} - {{ order.friendlyIdentifier() }}
        </ion-title>
        <ion-buttons slot="end">
          <ion-button @click="closeModal()">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list>
        <ion-item
          v-for="(lineItem, index) in order.items"
          :key="`item-${index}`"
          :data-cy="`order-item-${lineItem.id}`"
        >
          <ion-text slot="start">
            {{ lineItem.quantity }}
          </ion-text>
          <ion-label>
            {{ lineItem.name }}
            <span v-if="lineItem.options">
              - {{ lineItem.options.value.name }}
            </span>
            <p v-if="lineItem.instructions">{{ lineItem.instructions }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
      <div v-if="order.instructions">
        <strong>Instructions:</strong> {{ order.instructions }}
      </div>
    </ion-content>
  </div>
</template>

<script>
export default {
  props: {
    closeModal: {
      required: true,
      type: Function
    },
    order: {
      required: true,
      type: Object
    },
    customerName: {
      required: true,
      type: String
    }
  }
};
</script>

<style lang="scss">
.order-details-modal ion-content * {
  font-size: 1.5rem !important;
  line-height: normal;
  text-overflow: unset;
  white-space: initial;
}
</style>
